export { PropositionList } from './PropositionList';
